import { useProgramFavourites } from "../hooks/use-program-favourites";
import { FavouriteButton } from "./program-parts";

import type { ProgramNode } from "../../program-tree/program-tree";
import type { FC } from "react";

/** The star of a program or folder on its own page, which keeps it in the landing's Favourites. */
export const ProgramFavouriteButton: FC<{ node: ProgramNode }> = ({ node }) => {
  const { favourites, toggle } = useProgramFavourites();

  return (
    <FavouriteButton
      node={node}
      favourite={favourites.includes(node.id)}
      onToggle={() => void toggle(node.id)}
    />
  );
};
